import React from "react";
import { useLocation } from "react-router-dom";

import Header from "@/components/layout/Header/Header";
import Footer from "@/components/layout/Footer/Footer";

interface MarketingLayoutProps {
	children: React.ReactNode;
	hideMarketingNav?: boolean;
}

const MarketingLayout: React.FC<MarketingLayoutProps> = ({
	children,
	hideMarketingNav = false,
}) => {
	const location = useLocation();

	// Check if we're on search page to hide marketing nav
	const isSearchPage = location.pathname === "/search-doulas";
	const isDoulaProfilePage = location.pathname.startsWith("/doula-profile/");
	const isLoginPage = location.pathname === "/login";
	const isSignupPage = location.pathname === "/signup";
	const shouldHideMarketingNav =
		hideMarketingNav ||
		isSearchPage ||
		isDoulaProfilePage ||
		isLoginPage ||
		isSignupPage;

	return (
		<div className="min-h-screen bg-white">
			{/* Sticky Navigation */}
			<Header hideMarketingNav={shouldHideMarketingNav} />

			{/* Main Content */}
			<main className="pt-16">{children}</main>
			{/* Footer */}
			<Footer />
		</div>
	);
};

export default MarketingLayout;
